/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Smarts
 * (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import SmartsAPI from './SmartsAPI'

/*
	Temporary class to support legacy calling method
*/
export default class SmartsEntry extends SmartsAPI {

	/**
	 * When invoked as a library, glassContext can be passed in contructor.
	 *  eg. define(['bi/smarts-js/smarts'], (smarts) => { 
	 * 
	 * @param  {object} options - has glassContext
	 */
	constructor(options) {
		const { glassContext } = options
		super({
			logger: glassContext.getCoreSvc('.Logger'),
			ajaxService: glassContext.getCoreSvc('.Ajax')
		})
	}
}
